import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#4C8BF9"
      d="M12.327 15.357a.75.75 0 1 0-1.32-.713L9.34 17.727a.75.75 0 0 0 1.32.713zM14.327 18.357a.75.75 0 1 0-1.32-.713l-1.667 3.083a.75.75 0 1 0 1.32.713z"
    />
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 7.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 15H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
  </>
);

const Weather9Colored = Icon('weather-9-colored', svgContents);

export default Weather9Colored;
